import { toast } from 'react-toastify';

import moment from 'moment';

import api from '~/services/api';

export default async function dateTime() {
  try {
    const { data } = await api.get('datahorasistema');
    return moment(data.datahorasistema, 'DD/MM/YYYY HH:mm:ss');
  } catch (err) {
    err.map((e) => toast.error(e));
    return moment();
  }
}
